import axios, { AxiosInstance } from "axios";
import browserStorage from "../storage";
import { BaseResponse } from "./response/BaseResponse";

class Api {
  private api_token: string | null | undefined;
  private client: null | AxiosInstance;
  private api_url: any;
  private method: any;
  private branch: any;
  private organization: any;

  constructor() {
    this.api_token = null;
    this.client = null;
    this.api_url = process.env.REACT_APP_PRODUCTION_URL;
    this.method = "post";
    this.branch = null;
    if (process.env.NODE_ENV == "development") {
      this.organization = process.env.REACT_APP_DOMEN;
    }
  }
  init = () => {
    this.api_token = browserStorage.get("token");
    this.branch = browserStorage.get("branch");

    let headers: any = {
      Accept: "application/json",
      // feature flag
      Pragma: "no-cache",
      Authorization: "",
      branch: this.branch, // <- bu dinamic bo'lishi kerak!
    };
    // feature flag will be deleted soon!
    const branches = [
      "62f676a9fbc738743bfdd847",
      "62c6a8e25a8345f511208f44",
      "6260e456e5ceb67b3956bf34",
      "62f6756afbc738743bfdd835",
      "626991f8d515a52498a085cc",
      "62f6766cfbc738743bfdd843",
      "6266e5b45bbdd74734fe0f95",
      "62698284562cbe73f10ada0b",
      "6266eeee5bbdd74734fe240d",
      "62698a12d515a52498a071a6",
      "62f675acfbc738743bfdd837",
      "6310824985db9e197525809e",
      "6266d9e35bbdd74734fddadd",
      "625283143e8654cbe4b781eb",
      "624be05837f3f2552adc4fdb",
      "6260f8c39cd12f7b5a847f41",
      "6212f2fa0615b313e2eb83f5",
      "6260f2569cd12f7b5a846492",
      "6273e40b846f959c40317ae0",
      "6269b277838137b4f45195b3",
      "62f676c6fbc738743bfdd849",
      "62fa6ad750578b6f867b1d20",
      "62adc9188595fd19761040a1",
      "62f675cefbc738743bfdd839",
      "62f67647fbc738743bfdd83f",
      "625c8ba2fecdc9626699eb57",
      "62e3d02744add00a582f1c27",
      "62f67624fbc738743bfdd83d",
      "62f675fafbc738743bfdd83b",
      "62670885cf59c0e7409c30a8",
      "62f67686fbc738743bfdd845",
    ];
    if (branches.includes(this.branch)) {
      delete headers.Pragma;
    }
    if (this.organization) {
      headers.organization = this.organization;
    }
    if (this.api_token) {
      headers.Authorization = `Bearer ${this.api_token}`;
    }

    this.client = axios.create({
      baseURL: this.api_url,
      timeout: 300000,
      headers: headers,
    });

    return this.client;
  };

  async apiCall<T>(
    url: any = null,
    data: any = {},
    method: string = "post"
    //@ts-ignore
  ): Promise<BaseResponse<T>> {
    if (method === "post") {
      try {
        return this.init().post(url, data);
      } catch (error: any) {
        const code = error?.response?.data.code;
        if (code === 10013) {
          browserStorage.set("isFrozen", true);
        }
      }
    } else if (method == "put") {
      try {
        return this.init().put(url, data);
      } catch (error: any) {
        const code = error?.response?.data.code;
        if (code === 10013) {
          browserStorage.set("isFrozen", true);
        }
      }
    } else if (method == "delete") {
      try {
        return this.init().delete(url, data);
      } catch (error: any) {
        const code = error?.response?.data.code;
        if (code === 10013) {
          browserStorage.set("isFrozen", true);
        }
      }
    } else {
      try {
        const response: any = await this.init().get(url, data);
        if (browserStorage.get("isFrozen") && response.data.code === 0) {
          browserStorage.remove("isFrozen");
        }
        return response;
      } catch (error: any) {
        const code = error?.response?.data.code;
        if (code === 10013) {
          browserStorage.set("isFrozen", true);
        }
      }
    }
  }
}

export const api = new Api();
